export default "__VITE_ASSET__a0fd0668__"